var map = {
	"./eu/about/digital-design-principles/index.mdx": 657,
	"./eu/about/eu-values/index.mdx": 658,
	"./eu/about/getting-started/index.md": 659,
	"./eu/about/index.md": 660,
	"./eu/about/vision/index.mdx": 661,
	"./eu/about/what-new/index.md": 662,
	"./eu/about/what-next/index.md": 663,
	"./eu/accessibility/index.md": 664,
	"./eu/branding/digital-visual-identity/index.md": 665,
	"./eu/branding/index.md": 666,
	"./eu/branding/partnership/index.md": 667,
	"./eu/branding/taglines/index.md": 668,
	"./eu/branding/themes/index.md": 669,
	"./eu/components/index.md": 670,
	"./eu/download/icons-set/index.md": 671,
	"./eu/download/index.md": 672,
	"./eu/download/layers-typography-styles/index.md": 673,
	"./eu/download/swatch-palette/index.md": 674,
	"./eu/download/templates/index.md": 675,
	"./eu/download/ui-kit/index.md": 676,
	"./eu/download/visual-identity-assets/index.md": 677,
	"./eu/editorial/index.md": 678,
	"./eu/editorial/voice-tone/index.md": 679,
	"./eu/editorial/writing-style/index.md": 680,
	"./eu/getting-involved/give-feedback/index.md": 681,
	"./eu/getting-involved/index.md": 682,
	"./eu/getting-involved/new-components-request/index.md": 683,
	"./eu/index.md": 72,
	"./eu/layout-systems/grids/index.md": 684,
	"./eu/layout-systems/index.md": 685,
	"./eu/layout-systems/responsiveness-breakpoints/index.md": 686,
	"./eu/layout-systems/stacks/index.md": 687,
	"./eu/page-templates/article/index.md": 688,
	"./eu/page-templates/category/index.md": 689,
	"./eu/page-templates/contacts/index.md": 690,
	"./eu/page-templates/homepage/index.md": 691,
	"./eu/page-templates/index.md": 692,
	"./eu/page-templates/page-structure/index.md": 693,
	"./eu/page-templates/search-results/index.md": 694,
	"./eu/research-users/index.md": 695,
	"./eu/research-users/personas/index.md": 696,
	"./eu/ui-patterns/404/index.md": 697,
	"./eu/ui-patterns/communication/error/index.md": 698,
	"./eu/ui-patterns/communication/help-feedback/index.md": 699,
	"./eu/ui-patterns/communication/index.md": 700,
	"./eu/ui-patterns/content/articles-news/index.md": 701,
	"./eu/ui-patterns/content/empty-states/index.md": 702,
	"./eu/ui-patterns/content/home/index.md": 703,
	"./eu/ui-patterns/content/index.md": 704,
	"./eu/ui-patterns/content/navigation/index.md": 705,
	"./eu/ui-patterns/data/filter-sort/index.md": 706,
	"./eu/ui-patterns/data/index.md": 707,
	"./eu/ui-patterns/data/search/index.md": 708,
	"./eu/ui-patterns/index.md": 709,
	"./eu/ui-patterns/social/follow/index.md": 710,
	"./eu/ui-patterns/social/index.md": 711,
	"./eu/utilities/index.md": 712,
	"./eu/visual-language/colours/index.md": 713,
	"./eu/visual-language/images/index.md": 714,
	"./eu/visual-language/index.md": 715,
	"./eu/visual-language/motion/index.md": 716,
	"./eu/visual-language/shadows/index.md": 717,
	"./eu/visual-language/shapes/index.md": 718,
	"./eu/visual-language/spacing/index.md": 719,
	"./eu/visual-language/typography/index.md": 720
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return Promise.all(/* lazy-once context | eu-pages */[__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 348;
module.exports = webpackAsyncContext;